.side-sheet {
    width: 0;
    height: 100%;
    position: fixed;
    z-index: 9999; /* High z-index to overlay page content */
    top: 0;
    bottom: 0;
    overflow-x: hidden;
    overflow-y: hidden; /* change to auto to enable vertical scrolling */
    transition: width 0.5s ease;
    background-color: #ffffff; /* Add background color */
  
    /* Hide scrollbar for Chrome, Safari and Opera */
    ::-webkit-scrollbar {
      display: none;
    }
  
    /* Hide scrollbar for Firefox */
    scrollbar-width: none;
  
    /* Hide scrollbar for IE and Edge */
    -ms-overflow-style: none;
  }
  
  
  .side-sheet.left {
    left: 0;
  }
  
  .side-sheet.right {
    right: 0;
  }
  
  .side-sheet.open {
    width: 1300px
  }

  .side-sheet.short.open {
    width: 480px;
  }
  
  
  .backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 9; /* Lower than the side-sheet but higher than page content */
    opacity: 0;
    pointer-events: none; /* By default, do not block interactions */
    transition: opacity 0.5s ease;
  }
  
  .backdrop.open {
    opacity: 1;
    pointer-events: auto; /* Allow interactions when visible */
  }

  .title {
   display: flex;
   flex: 1;
   align-items: center;
  }
  
  .close-button {
    display: flex;
    align-items: center;
  }

  .ag-root.ag-layout-normal {
    font-family: sans-serif !important;
    font-size: 13px;
  }

  .side-sheet.custom-width.open {
    transition: width 0.5s ease; /* Same transition */
  }